import React from "react";
import { Input } from "@mui/material";
import PropTypes from "prop-types";
import ListOfTitle from "components/ListOfTitle/ListOfTitle";

function InputComponent({
  onChange,
  searchInputField,
  searchTitleData,
  setSearchItemArray,
}) {
  return (
    <div className="b-input-container">
      <Input
        className="font-bold b-input-container__inputField"
        variant="outlined"
        placeholder="Enter Title"
        value={searchInputField}
        onChange={onChange}
      />
      <ListOfTitle
        searchData={searchTitleData}
        clickEvent={setSearchItemArray}
      />
    </div>
  );
}
InputComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  searchInputField: PropTypes.string.isRequired,
  // searchTitleData: PropTypes.arrayOf([]).isRequired,
  searchTitleData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  setSearchItemArray: PropTypes.func.isRequired,
};
export default InputComponent;
